import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { useRef } from 'react';

import { GOOGLE_MAPS_CONFIG, MAP_OPTIONS } from '../../constants/maps';

const headQuartersPostion = {
  // coordinates of headquarters in Waregem
  lat: 50.88026,
  lng: 3.35074,
};

type Map = google.maps.Map & { zoom: number };

const HeadQuartersMap = () => {
  const { isLoaded: isMapLoaded } = useJsApiLoader(GOOGLE_MAPS_CONFIG);

  const mapRef = useRef<Map>();

  const handleMapLoad = (map: google.maps.Map) => {
    mapRef.current = map as Map;
  };

  if (!isMapLoaded) {
    return null;
  }

  return (
    <div className="aspect-square w-full">
      <GoogleMap
        center={headQuartersPostion}
        clickableIcons={false}
        mapContainerStyle={{ width: '100%', height: '100%' }}
        onLoad={handleMapLoad}
        options={{ ...MAP_OPTIONS, zoomControl: false }}
        zoom={15}
      >
        <Marker position={headQuartersPostion} />
      </GoogleMap>
    </div>
  );
};

export default HeadQuartersMap;
